export class TipoEnderecoModel {
    id: number;
    descricao: String;
}



// WEBPACK FOOTER //
// /app/src/app/model/endereco/tipoendereco.model.ts